import {Component, Input} from '@angular/core';
import {Lookups, WspayConfirmation, PaymentStatus} from "@model";

@Component({
  selector: 'app-user-profile-events-tab',
  templateUrl: './user-profile-events-tab.component.html',
  styleUrls: ['./user-profile-events-tab.component.scss']

})
export class UserProfileEventsTabComponent {
  @Input({required:true}) languages: Lookups[] = [];
  // TODO remove this - for UI testing
  wspayConfirmation: WspayConfirmation = {
    paymentStatus: PaymentStatus.PENDING,
  };
}
